import * as React from 'react';
import styled from 'styled-components';
import { ProfileImageError } from 'kb-shared';
import profilePlaceholder from '../../../../assets/icons/placeholder-profile.svg';

import { imageSize } from '../../lib/common';

interface ImageProps {
  size?: number;
}

const Image = styled.img`
  ${(props: ImageProps) => imageSize(props.size)}
`;

const UserImage = styled(Image)`
  border-radius: 50%;
`;

type Props = {
  profileImage?: string;
  error: ProfileImageError | null;
  size?: number;
  onError: () => void;
};

const ProfileImage = (props: Props) => {
  const { profileImage, onError, size, error } = props;

  return profileImage && !error ? (
    <UserImage src={profileImage} alt="Profile photo" onError={onError} size={size} />
  ) : (
    <Image src={profilePlaceholder} alt="Profile photo" size={size} />
  );
};

export default ProfileImage;
